import React from 'react';
import styles from './MobileAboutPage.module.css';
import AlanHeadshot from '../../assets/Alan_Iannaccone_Headshot.webp';
import AustinHeadshot from '../../assets/Austin_Long_headshot.webp';

// Asset paths (hero images removed for mobile)

export default function MobileAboutPage() {
  return (
    <main className={styles.page}>
      {/* About Section (Authority Mode) */}
      <section className={styles.aboutSection}>
        <h1 className={styles.aboutH1}>About DocuHounds</h1>
        <h2 className={styles.aboutH2}>Built to remove friction.
        Designed to give time back.</h2>
        <div className={styles.aboutBody}>
          <p>DocuHounds is an AI-powered academic operating system built by engineers and operators who were tired of chaos.</p>
          <p>We turn syllabi, documents, and deadlines into a single intelligent workflow. Automatically.</p>
          <p>Students don’t need more tools. They need a system.</p>
        </div>
      </section>

      <hr className={`${styles.sectionDivider} ${styles.mutedDivider}`} />

      {/* Founders Section — Hard Reset */}
      <section className={styles.foundersSection}>
        <div className={styles.foundersHeader}>
          <h2 className={styles.foundersTitle}>The Founders</h2>
          <div className={styles.foundersSub}>LEADERSHIP. ENGINEERING. EXECUTION.</div>
        </div>

        <div className={styles.founderRail}>
          <article className={styles.founderCard}>
            <img src={AlanHeadshot} alt="Alan Iannaccone" className={styles.avatarSquare} />
            <div className={styles.founderInfoRight}>
              <div>
                <h3 className={styles.founderName}>Alan Iannaccone, PE</h3>
                <div className={styles.founderTitle}>Co-Founder & CEO</div>
                <div className={styles.founderBadge}>Licensed Professional Engineer</div>
              </div>
              <p className={styles.founderBio}>Licensed Professional Engineer and MBA candidate at Boston College. Alan leads product vision, strategy, and user experience at DocuHounds. He founded the company after experiencing firsthand how broken academic workflows waste time, focus, and potential.</p>
              <p className={styles.founderKicker}>He sets the standard the system is built to meet.</p>
            </div>
          </article>

          <article className={styles.founderCard}>
            <img src={AustinHeadshot} alt="Austin Long" className={styles.avatarSquare} />
            <div className={styles.founderInfoRight}>
              <div>
                <h3 className={styles.founderName}>Austin Long</h3>
                <div className={styles.founderTitle}>Co-Founder & CTO</div>
                <div className={styles.founderBadge}>15+ Years Engineering Experience</div>
              </div>
              <p className={styles.founderBio}>Software engineer with over 15 years of experience building production systems. Austin leads architecture, AI infrastructure, and platform reliability at DocuHounds. He designs systems that scale, automate, and don’t break.</p>
              <p className={styles.founderKicker}>Reliability is not a feature. It’s the baseline.</p>
            </div>
          </article>
        </div>
      </section>

      <hr className={`${styles.sectionDivider} ${styles.mutedDivider}`} />

      {/* Statement Card (replace CTA) */}
      <section className={styles.statementSection}>
        <div className={styles.statementCard}>
          <h3 className={styles.statementTitle}>Built by students.<br/>Engineered to hold up.</h3>
          <ul className={styles.statementList}>
            <li>— Student-first by design</li>
            <li>— Automation that saves real hours every week</li>
            <li>— Fewer tools. Less noise. More control.</li>
          </ul>
        </div>
      </section>

      <hr className={`${styles.sectionDivider} ${styles.spacedDivider}`} />

      {/* Mission Section — Stripped Down */}
      <section className={styles.missionSection}>
        <div className={styles.missionCard}>
          <h3 className={styles.missionTitle}>The Mission</h3>
          <p className={styles.missionText}>We remove friction from academic life so students stay ahead of deadlines, stay organized, and focus on learning—not logistics.</p>
        </div>
      </section>

      <hr className={styles.sectionDivider} />

      {/* Final Silent Warning */}
      <section className={styles.warningSection}>
        <p className={styles.warningMain}>DocuHounds isn’t a feature set. It’s a system.</p>
        <p className={styles.warningSub}>We’re not chasing trends. We’re building infrastructure for how students actually work.</p>
      </section>
    </main>
  );
}
